import AddressLabelCell from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const stopFields = ['address'];
const journeyFields = ['route'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { address } = props.selectors.getJourneyStopFields(
      state,
      props.journeyId,
      props.stopId,
      stopFields
    );

    const { route } = props.selectors.getJourneyFields(state, props.journeyId, journeyFields);
    const { label: addressLabel, country: stopCountry, zipcode: stopZipcode } = address;
    return {
      addressLabel,
      stopCountry,
      stopZipcode,
      isInternational: route && route.country === 'EU',
    };
  })
);

export default enhance(AddressLabelCell);
